import {ReqState} from "lib/reqstate";
import {ACTTYPE_INIT_STATE} from "./appstate.js";

const ACTTYPE_SET_SCHOOLPUBLICINFO = "schoolInfo/SET_SCHOOLPUBLICINFO";
const ACTTYPE_ERR_SCHOOLPUBLICINFO = "schoolInfo/ERR_SCHOOLPUBLICINFO";
const ACTTYPE_SET_SCHOOLINFO = "schoolInfo/SET_SCHOOLINFO";
const ACTTYPE_ERR_SCHOOLINFO = "schoolInfo/ERR_SCHOOLINFO";
const ACTTYPE_CLR_SCHOOLINFO = "schoolInfo/CLR_SCHOOLINFO";


const initialState = {
  // SchoolPublicInfo
  siteName: "",
  sid: "",
  dataEndpoint: [],
  liffId: "",
  lineId: "",
  schoolName: "",
  img:"",
  color: "",
  backgroundImage: "",
  generalInfo: {},
  maint: {active: "0", msg: ""},
  minRes: "5",
  var: 0,

  // SchoolInfo
  opt: {},
  uopt: {
    mealSchedule: [],
  },
  classGroupList: [],
  classList: [],
  renrakuFields: [],
  osiraseKinds: [],
  tags: [],

  loadingStateSchoolPublicInfo: ReqState.INIT,
  loadingStateSchoolInfo: ReqState.INIT,
};


const setSchoolPublicInfo = function(schoolPublicInfo) {
  return {
    type: ACTTYPE_SET_SCHOOLPUBLICINFO,
    value: schoolPublicInfo,
  };
};


const errSchoolPublicInfo = function() {
  return {
    type: ACTTYPE_ERR_SCHOOLPUBLICINFO,
  };
};


const setSchoolInfo = function(schoolInfo) {
  return {
    type: ACTTYPE_SET_SCHOOLINFO,
    value: schoolInfo,
  };
};


const errSchoolInfo = function() {
  return {
    type: ACTTYPE_ERR_SCHOOLINFO,
  };
};


const clrSchoolInfo = function() {
  return {
    type: ACTTYPE_CLR_SCHOOLINFO,
  };
};

const reducer = function (state, action) {
  if (typeof state === "undefined") {
    state = initialState;
  }

  switch (action.type) {
  case ACTTYPE_INIT_STATE:
    return {...initialState};
  case ACTTYPE_SET_SCHOOLPUBLICINFO:
    return Object.assign(
      {},
      state,
      {
        ...action.value,
        loadingStateSchoolPublicInfo: ReqState.DONE
      }
    );
  case ACTTYPE_ERR_SCHOOLPUBLICINFO:
    return Object.assign({}, state, {
      loadingStateSchoolPublicInfo: ReqState.ERROR,
    });
  case ACTTYPE_SET_SCHOOLINFO:
    /* データ追加時はACTTYPE_CLR_SCHOOLINFOにクリア処理を追加すること */
    return Object.assign(
      {},
      state,
      {
        ...action.value,
        loadingStateSchoolInfo: ReqState.DONE,
      },
    );
  case ACTTYPE_ERR_SCHOOLINFO:
    return Object.assign({}, state, {
      loadingStateSchoolInfo: ReqState.ERROR,
    });
  case ACTTYPE_CLR_SCHOOLINFO:
    return Object.assign(
      {},
      state,
      {
        opt: initialState.opt,
        uopt: initialState.uopt,
        classGroupList: initialState.classGroupList,
        classList: initialState.classList,
        renrakuFields: initialState.renrakuFields,
        osiraseKinds: initialState.osiraseKinds,
        tags: initialState.tags,
        loadingStateSchoolInfo: ReqState.INIT,
      },
    );
  default:
    break;
  }

  return state;
};


export {
  reducer as default,
  initialState as schoolInfoInitialState,
  setSchoolPublicInfo,
  errSchoolPublicInfo,
  setSchoolInfo,
  errSchoolInfo,
  clrSchoolInfo,
};
